import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import { Typography } from '@mui/material'

import { React, useState } from 'react'

import { useNavigate } from 'react-router-dom'
import AdxButton from 'components/custom/AdxButton'

const LearnMoreModal = () => {
  const navigate = useNavigate()
  const [modalState, setModalState] = useState(false)
  const [isButtonLoading, setIsButtonLoading] = useState(false)

  const handleOpen = () => {
    setModalState(true)
  }

  const handleClose = () => {
    setModalState(false)
  }

  return (
    <>
      <Typography
        onClick={handleOpen}
        variant="body2"
        sx={{
          cursor: 'pointer',

          textDecoration: 'underline',
          color: 'alternate.main',
        }}
      >
        Learn More
      </Typography>
      <AdxInfoModal
        title=""
        subtitle=""
        muiIcon="error"
        iconColor="info.main"
        open={modalState}
        onClose={handleClose}
        handleClose={handleClose}
        footerButtons
        firstBtnLabel={'Back'}
        firstBtnHandle={handleClose}
      >
        <Typography variant="subtitle1">
          Download the CSV file and key in the details of all your staff to import in bulk. Please
          follow the set format to avoid errors.
        </Typography>
      </AdxInfoModal>
    </>
  )
}

export default LearnMoreModal
